import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { TWO_FACTOR_AUTHENTICATION_DIALOG_ID } from "@obg/common.verification";
import { take } from "rxjs/operators";

import { ALL_FLOW_DIALOGS_IDS, SMART_ID_LOGIN_DIALOG_ID } from "./login-flow-dialog.const";

@Injectable({
	providedIn: "root",
})
export class LoginFlowDialogService {
	constructor(private matDialog: MatDialog) {}

	openDialog(openFunc: () => void, dialogId: string) {
		const anyFlowDialog = this.findOpenDialog();
		if (!anyFlowDialog) {
			openFunc();
			return;
		}

		if (anyFlowDialog.id === dialogId) {
			return;
		}

		// eslint-disable-next-line rxjs/no-ignored-subscription
		anyFlowDialog.afterClosed().pipe(take(1)).subscribe(openFunc);
		anyFlowDialog.close();
	}

	closeSmartIdVerificationDialog() {
		this.matDialog.openDialogs.find((d) => SMART_ID_LOGIN_DIALOG_ID === d.id)?.close();
	}

	closeTwoFactorAuthDialog() {
		this.matDialog.openDialogs.find((d) => TWO_FACTOR_AUTHENTICATION_DIALOG_ID === d.id)?.close();
	}

	closeAllDialogs() {
		// assuming that there's can be only one dialog from the flow currently open,
		// it's enough to close first found
		const anyFlowDialog = this.matDialog.openDialogs?.find((d) => ALL_FLOW_DIALOGS_IDS.includes(d.id));
		if (anyFlowDialog) {
			anyFlowDialog.close();
		}
	}

	private findOpenDialog() {
		return this.matDialog.openDialogs.find((d) => ALL_FLOW_DIALOGS_IDS.includes(d.id));
	}
}
